// The backend stores prices and wallet balances in US dollars. They are shown in rupees,
// converted at a fixed rate (≈ market rate, Oct 2026). A whole-number rate keeps every
// line and total exact, so the cart always adds up. Change it here if needed.
export const USD_TO_INR = 95;

// Rupees with Indian digit grouping, e.g. ₹1,14,000.
export const money = (usd) => `₹${Math.round((Number(usd) || 0) * USD_TO_INR).toLocaleString("en-IN")}`;

// Some product names are stored in capitals; show them in title case.
export const displayName = (name = "") => {
  const trimmed = name.trim();
  return trimmed === trimmed.toUpperCase()
    ? trimmed.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
    : trimmed;
};

export const CATEGORY_STYLE = {
  Fashion: { tint: "#f6e9e3", ink: "#8a4b35", icon: "M12 7a2 2 0 1 1 2-2M12 7v2l9 6H3l9-6" },
  Sports: {
    tint: "#e3f1e6",
    ink: "#2f6b3e",
    icon: "M12 4a8 8 0 1 0 0 16a8 8 0 1 0 0-16M4 12h16M12 4c3 3 3 13 0 16M12 4c-3 3-3 13 0 16",
  },
  Electronics: {
    tint: "#e4ebf6",
    ink: "#34558a",
    icon: "M5 4h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM8 20h8M12 16v4",
  },
  "Home & Kitchen": { tint: "#f3eedf", ink: "#6e5c2c", icon: "M8 3h8l3 8H5zM12 11v8M8 21h8" },
  Books: { tint: "#ede6f5", ink: "#5e4688", icon: "M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2zM4 19V5" },
};
const FALLBACK_STYLE = { tint: "#eef1ee", ink: "#5a6b62", icon: "M6 7h12l-1 13H7zM9 7a3 3 0 0 1 6 0" };
export const categoryStyle = (category) => CATEGORY_STYLE[category] || FALLBACK_STYLE;

export const SORTS = [
  { value: "featured", label: "Featured" },
  { value: "price-asc", label: "Price: low to high" },
  { value: "price-desc", label: "Price: high to low" },
  { value: "rating", label: "Top rated" },
];

export const sortProducts = (products, sort) => {
  const list = [...products];
  if (sort === "price-asc") list.sort((a, b) => a.cost - b.cost);
  if (sort === "price-desc") list.sort((a, b) => b.cost - a.cost);
  if (sort === "rating") list.sort((a, b) => b.rating - a.rating || a.cost - b.cost);
  return list;
};

// Joins the cart ([{ productId, qty }]) with product details.
export const cartLines = (cart, products) => {
  const byId = new Map(products.map((p) => [p._id, p]));
  return cart
    .map((item) => {
      const product = byId.get(item.productId);
      return product ? { ...product, qty: item.qty, lineTotal: product.cost * item.qty } : null;
    })
    .filter(Boolean);
};

export const cartTotals = (lines) => ({
  count: lines.reduce((sum, l) => sum + l.qty, 0),
  total: lines.reduce((sum, l) => sum + l.lineTotal, 0),
});
